import styled from 'styled-components';

export const Range = styled.div`
  .range-number {
    top: -22px;
    left: 22px;
    transform: translateX(-50%);
    padding: 4px 8px;
    white-space: nowrap;
    pointer-events: none;
    z-index: 2;
    transition: left 0.05s ease-out;
  }
`;
